/*
 * Copyright (c) 2026. Orion Analytics. All Rights Reserved
 */

/*
 * Copyright (c) 2026. Orion Analytics.
 * All Rights Reserved.
 */

import NetPositionChart
    from "./NetPositionChart";

import ClientSnapshotChart
    from "./ClientSnapshotChart";

import ClientTrendChart
    from "./ClientTrendChart";

import PositioningSummaryCard
    from "./PositioningSummaryCard";

export default function FuturesPositioning({

    trendData,
    latestData

}) {

    return (

        <div
            className="
                space-y-6
            "
        >

            {/* SUMMARY */}

            <PositioningSummaryCard
                latestData={latestData}
            />

            {/* NET POSITION */}

            <NetPositionChart
                latestData={latestData}
            />

            {/* LONG VS SHORT SNAPSHOT */}

            <ClientSnapshotChart
                latestData={latestData}
            />

            {/* TREND */}

            <ClientTrendChart
                trendData={trendData}
            />

        </div>

    );

}